import { MaskedLines, Eyebrow } from "@/components/motion";
import { motion } from "framer-motion";

const PageHero = ({ eyebrow, title, sub }) => (
  <section className="bg-ink dot-texture pt-36 pb-16 lg:pt-44 lg:pb-24" data-testid="page-hero">
    <div className="container-site">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }}>
        <Eyebrow dark>{eyebrow}</Eyebrow>
      </motion.div>
      <MaskedLines
        lines={[title]}
        className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight text-white mt-4 leading-[1.05]"
      />
      {sub && (
        <motion.p
          className="text-gray-400 text-base sm:text-lg mt-6 max-w-2xl leading-relaxed"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
        >
          {sub}
        </motion.p>
      )}
    </div>
  </section>
);

export default PageHero;
